import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import SimpleCta from 'components/simple-cta'
import WidgetPage from 'components/hocs/widget-page'

const variations = {
  'compare-student-loan-rates': 'Compare Student Loan Rates',
  'learn-about-student-loans': 'Learn About Student Loans',
  'compare-rates': 'Compare Rates',
  'find-my-rate': 'Find My Rate',
  'learn-more': 'Learn More',
}
export const SimpleCtaApp = (props) => {
  const { variation } = props

  const url = `${config.credibleRoot}/student-loans`

  return (
    <SimpleCta
      url={url}
      variations={variations}
      large={variations[variation]?.length > 20}
      {...props}
    />
  )
}

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
}

export default WidgetPage(SimpleCtaApp)
